import {
    infoColor, infoBoxShadow, successColor, dangerColor,
} from '../global';

const QAListManagermentStyle = {
    main: {
        // padding: '23px',
        marginBottom: '20px',
    },
    fieldset: {
        borderColor: infoColor,
        borderRadius: '8px',
        ...infoBoxShadow,
        padding: '26px',
    },
    button: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    addButton: {
        marginLeft: '-6px',
        color: successColor,
        padding: '20px',
    },
    advertisementRemoveButton: {
        position: 'absolute',
        right: '20px',
        top: '20px',
        color: dangerColor,
        zIndex: 1,
    },
};

export default QAListManagermentStyle;
